/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { AxiosHttpRequest } from './core/AxiosHttpRequest';
import { ApiKeysService } from './services/ApiKeysService';
import { AuthenticationService } from './services/AuthenticationService';
import { IdentifyGroupsService } from './services/IdentifyGroupsService';
import { IdentifyPeopleService } from './services/IdentifyPeopleService';
import { InvitesService } from './services/InvitesService';
import { JudgeService } from './services/JudgeService';
import { JudgesService } from './services/JudgesService';
import { LargeLanguageModelsService } from './services/LargeLanguageModelsService';
import { NotesService } from './services/NotesService';
import { PermissionScopesService } from './services/PermissionScopesService';
import { ProjectsService } from './services/ProjectsService';
import { ProjectTokensService } from './services/ProjectTokensService';
import { QueriesService } from './services/QueriesService';
import { ShotsService } from './services/ShotsService';
import { StreamService } from './services/StreamService';
import { TelemetryService } from './services/TelemetryService';
import { TrackService } from './services/TrackService';
import { WorkspaceMembersService } from './services/WorkspaceMembersService';
import { WorkspacesService } from './services/WorkspacesService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class ZirpApiClient {
    public readonly apiKeys: ApiKeysService;
    public readonly authentication: AuthenticationService;
    public readonly identifyGroups: IdentifyGroupsService;
    public readonly identifyPeople: IdentifyPeopleService;
    public readonly invites: InvitesService;
    public readonly judge: JudgeService;
    public readonly judges: JudgesService;
    public readonly largeLanguageModels: LargeLanguageModelsService;
    public readonly notes: NotesService;
    public readonly permissionScopes: PermissionScopesService;
    public readonly projects: ProjectsService;
    public readonly projectTokens: ProjectTokensService;
    public readonly queries: QueriesService;
    public readonly shots: ShotsService;
    public readonly stream: StreamService;
    public readonly telemetry: TelemetryService;
    public readonly track: TrackService;
    public readonly workspaceMembers: WorkspaceMembersService;
    public readonly workspaces: WorkspacesService;
    public readonly request: BaseHttpRequest;
    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = AxiosHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? 'https://api.zirp.dev',
            VERSION: config?.VERSION ?? '0.0.1',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });
        this.apiKeys = new ApiKeysService(this.request);
        this.authentication = new AuthenticationService(this.request);
        this.identifyGroups = new IdentifyGroupsService(this.request);
        this.identifyPeople = new IdentifyPeopleService(this.request);
        this.invites = new InvitesService(this.request);
        this.judge = new JudgeService(this.request);
        this.judges = new JudgesService(this.request);
        this.largeLanguageModels = new LargeLanguageModelsService(this.request);
        this.notes = new NotesService(this.request);
        this.permissionScopes = new PermissionScopesService(this.request);
        this.projects = new ProjectsService(this.request);
        this.projectTokens = new ProjectTokensService(this.request);
        this.queries = new QueriesService(this.request);
        this.shots = new ShotsService(this.request);
        this.stream = new StreamService(this.request);
        this.telemetry = new TelemetryService(this.request);
        this.track = new TrackService(this.request);
        this.workspaceMembers = new WorkspaceMembersService(this.request);
        this.workspaces = new WorkspacesService(this.request);
    }
}

